'use strict';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import noop from 'lodash/noop';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import {logModalError} from '../react-modals/utils';
import {epicErrorHandler} from '../rx-utils';
import {AbstractEpics} from '../redux/AbstractEpics';


export class ReactReduxModalEpics extends AbstractEpics {
  /**
   * @param {ReactReduxModalActions} actions
   * @param {ReactReduxModalOptions} options
   */
  constructor(actions, options) {
    super(options);
    /** @type {ReactReduxModalActions} **/
    this.actions = actions;
    /** @param {ReactReduxModalOptions} */
    this.options = options;

    if (options.modalOptions) {
      if (options.modalOptions.onSuccessAction) {
        if (!options.modalOptions.onSuccessAction.type) {
          throw new Error('ReactReduxModalEpics modalOptions.onSuccessAction must be a redux action');
        } else {
          this.onSuccessAction = options.modalOptions.onSuccessAction;
        }
      }

      if (options.modalOptions.onErrorAction) {
        if (!options.modalOptions.onErrorAction.type) {
          throw new Error('ReactReduxModalEpics modalOptions.onErrorAction must be a redux action');
        } else {
          this.onErrorAction = options.modalOptions.onErrorAction;
        }
      }
    }

    /** @type {Logger} **/
    this.logger = this.options.logger;

    this.onShowModal = this.onShowModal.bind(this);
    this.addEpic(this.onShowModal);
    this.onShowModal.$inject = [
      'modalManager',
    ];
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param dependencies
   */
  onShowModal(action$, store, dependencies) {
    let modal$;

    return action$.ofType(this.actions.showModal.TYPE)
      .mergeMap(action => {
        if (!modal$) {
          modal$ = dependencies.modalManager.create(this.options.modalComponent, this.options.modalOptions);
        }

        // allow each showModal call to overwrite the action(s) to use.
        const onSuccessAction = get(action, 'payload.onSuccessAction', this.onSuccessAction);
        const onSuccess = get(action, 'meta.resolve', noop);
        const onErrorAction = get(action, 'payload.onErrorAction', this.onErrorAction);
        const onError = get(action, 'meta.reject');

        let show$ = modal$
          .do(onSuccess);

        if (!onSuccessAction && !onErrorAction) {
          /* Do not emit any actions by default */
          const logError = logModalError(this.logger, 'onShowModal modal');
          return show$
            .catch(!onError ? logError : (err, src$) => {
              onError(err);
              return logError(err, src$);
            })
            .filter(() => false);
        }

        if (onSuccessAction) {
          show$ = show$
            .map(result => {
              const action = cloneDeep(onSuccessAction);
              action.payload = result;
              return action;
            });
        }

        if (onErrorAction) {
          show$ = show$
            .catch(err => {
              const action = cloneDeep(onErrorAction);
              action.payload = err;
              return Observable.of(action);
            });
        } else {
          show$ = show$
            .catch(logModalError(this.logger, 'onShowModal modal'));
        }

        return show$;
      })
      .catch(epicErrorHandler(this.logger, 'onShowModal epic'));
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-redux-modals/epics.js